import { createActionGroup, props } from '@ngrx/store';

export const i18nActions = createActionGroup({
    source: 'i18n',
    events: {
        'Initialize i18n': props<{ data: Array<{ FieldName: string; FieldValue: string }> }>(),
    },
});
